import React, { useEffect, useState } from "react";
import Modal from "components/BaseWidgets/modal";
import "./style.scss";
import { CloseIcon } from "assets/icons";
import Divider from "components/BaseWidgets/divider";
import Button from "components/BaseWidgets/button";
import Working from "./components/Working";
import CopyInput from "./components/CopyInput";
import HeaderInfo from "./components/HeaderInfo";
import Footer from "./components/Footer";
import { useReferModal } from "context/ReferModalProvider";
import AlertNotification from "components/CustomWidgets/alertNotification";
import { retrieveToken } from "utils/storage";

function ReferFriendModal() {
  const { referOpen, setReferOpen } = useReferModal();
  const user = JSON.parse(retrieveToken("user"));
  const referCode = user?.refer_code;
  const ref_link = user?.refer_link;

  const handleSendInvites = async () => {
    try {
      await navigator.clipboard.writeText(`${ref_link}`);
      AlertNotification("success", "Site link copied!");
    } catch (error) {
      console.error("Clipboard API failed, using fallback", error);
      const textArea = document.createElement("textarea");
      textArea.value = `${ref_link}`;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      AlertNotification("success", "Site link copied!");
    }
  };

  return (
    <Modal
      width={788}
      isOpen={referOpen}
      onCancel={() => setReferOpen(false)}
      title="Refer a friend"
      className="refer-friend-modal"
      // footer={<Footer />}
      centered
      closeIcon={<CloseIcon />}
      closable
    >
      <div className="flex flex-col gap-6 items-center content">
        <HeaderInfo />
        <div className="flex flex-col gap-4 items-center">
          <CopyInput className="copy-input" value={referCode} />
          <Button
            variant="secondary"
            className="invite-btn"
            onClick={handleSendInvites}
          >
            Send Invites
          </Button>
        </div>
      </div>
      <Divider color="#672666" />
      <Working />
    </Modal>
  );
}

export default ReferFriendModal;
